import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Fato } from 'src/app/models/fato.model';
import { daApi, MAP_FATO, paraApi } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class FatoService {

  constructor(
    public api: ApiService
  ) { }

  get(): Observable<Fato> {
    return this.api.get('/fact').pipe(map((res: any) => res ? daApi(res, MAP_FATO) : new Fato()));
  }

  // Registro unico: o POST da API faz insere-ou-altera.
  patch(fato: Fato): Observable<any> {
    return this.api.post('/fact', paraApi(fato, MAP_FATO));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}
